import { Annotation, FourdCesiumHelper, PlottableReference, Renderer } from "4d-mapper"
import { Observable, of } from "rxjs"

var Cesium = window['Cesium']

export class AnnotationRenderer extends Renderer<Annotation>{
	constructor(private cesium:FourdCesiumHelper){
		super()
		if(!Cesium) Cesium = window['Cesium']

	}
	onAdd(p: Annotation,args?:any): Observable<PlottableReference> {
		var pin = {
			position: p.catresian(),
			name: p.name,
			text: p.name,
			fourd_ref:p.id,
			font : '14px monospace',
			horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
			verticalOrigin : Cesium.VerticalOrigin.TOP,
			disableDepthTestDistance : 20,
			billboard : {
				heightReference:p.lheight?Cesium.HeightReference.NONE:Cesium.HeightReference.CLAMP_TO_GROUND,
				image : null,
				verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
				disableDepthTestDistance:Number.POSITIVE_INFINITY
			}
		}

		var caption = {
			position:p.catresian(),
			name:p.name,
			text:p.name,
			showBackground : true,
			fourd_ref: p.id,
			font : '14px monospace',
			horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
			verticalOrigin :Cesium.VerticalOrigin.TOP,
			disableDepthTestDistance : 20
		}
			
		if(!p.style || !p.style.hidePin)
			pin = this.cesium.annotationDataSource.entities.add(pin)
		if(p.style && p.style.caption)
			caption = this.cesium.annotationLabels.add(caption)

		var ref = {
			object:{
				pin:!p.style || !p.style.hidePin?pin:null,
				label:p.style && p.style.caption?caption:null
			},
			plottable:p
		}
		// if theres a byo style function
		if(args && args.styleFunction)
			args.styleFunction(ref)

		// console.log('##pin2',pin,ref);

		return of(ref)
	}	
	onRemove(obj: Annotation, pr: PlottableReference): Observable<PlottableReference> {
	
		if(pr.object.pin)
			this.cesium.annotationDataSource.entities.remove(pr.object.pin)
		if(pr.object.label)
			this.cesium.annotationLabels.remove(pr.object.label)

		return of(null)
	}


}

